import * as t from 'io-ts';
export var readonlyRecord = function (domain, codomain, name) {
    return t.readonly(t.record(domain, codomain), name);
};
